<template>
  <div class="hiaTable level2">
    <table
      ref="cptGrid"
      id="cptGrid"
      class="cpt-table"
      :class="{ truCodeEnabled: isTrucodeEnabled() }"
    >
      <colgroup>
        <col class="oneHundredPx" />
        <col class="seventyFivePx" />
        <col class="twentyPercent" />
        <col class="oneHundredPx" />
        <col class="seventyFivePx" />
        <col class="twentyPercent" />
        <col class="oneHundredPx" />
        <col class="seventyFivePx" />
        <col class="twentyPercent" />
        <col class="reasonForChangeCol" />
        <col class="responseCol" />
      </colgroup>
      <thead>
        <tr v-if="worksheet.cpts.length > 0" class="code-type-header-row">
          <th colspan="3" class="codeTypeHeader groupBlock groupDividerEnd">{{ worksheet.cpts[0].preCptCodeDesc }}</th>
          <th colspan="3" class="codeTypeHeader groupBlock groupDividerStart groupDividerEnd">{{ worksheet.cpts[0].codeDesc }}</th>
          <th colspan="3" class="codeTypeHeader groupBlock groupDividerStart groupDividerEnd">Recommended CPT Coding</th>
          <th colspan="2" class="groupDividerStart">&nbsp;</th>
        </tr>
        <tr>
          <th class="top-header">CPT</th>
          <th class="top-header">Mods</th>
          <th class="top-header groupDividerEnd">Desc.</th>
          <th class="top-header groupDividerStart">CPT</th>
          <th class="top-header">Mods</th>
          <th class="top-header groupDividerEnd">Desc.</th>
          <th class="top-header groupDividerStart">Rec. CPT</th>
          <th class="top-header">Mods</th>
          <th class="top-header groupDividerEnd">Desc.</th>
          <th class="top-header groupDividerStart">Reason For Change</th>
          <th class="top-header">&nbsp;</th>
        </tr>
        <tr v-if="isTrucodeEnabled()">
          <th class="bottom-header" style="padding-right: 0px;">
            <div class="feeScheduleHeader">
              <div>Work RVU</div>
            </div>
          </th>
          <th class="bottom-header" style="padding: 2px 0px 8px 0px;">
            <div class="feeScheduleHeader">
              <div class="feeScheduleHeaderChild">Global Surgery</div>
            </div>
          </th>
          <th class="bottom-header groupDividerEnd" style="padding: 2px 8px 8px 0px;">
            <div style="display: flex;">
              <div class="feeScheduleHeader">
                <div class="feeScheduleHeaderChild">Assistant at Surgery</div>
              </div>
              <div class="feeScheduleHeader">
                <div class="feeScheduleHeaderChild">Co-Surgeons</div>
              </div>
            </div>
          </th>
          <th class="bottom-header groupDividerStart" style="padding-right: 0px;">
            <div class="feeScheduleHeader">
              <div>Work RVU</div>
            </div>
          </th>
          <th class="bottom-header" style="padding: 2px 0px 8px 0px;">
            <div class="feeScheduleHeader">
              <div class="feeScheduleHeaderChild">Global Surgery</div>
            </div>
          </th>
          <th class="bottom-header groupDividerEnd" style="padding: 2px 8px 8px 0px;">
            <div style="display: flex;">
              <div class="feeScheduleHeader">
                <div class="feeScheduleHeaderChild">Assistant at Surgery</div>
              </div>
              <div class="feeScheduleHeader">
                <div class="feeScheduleHeaderChild">Co-Surgeons</div>
              </div>
            </div>
          </th>
          <th class="bottom-header groupDividerStart" style="padding-right: 0px;">
            <div class="feeScheduleHeader">
              <div>Rec. Work RVU</div>
            </div>
          </th>
          <th class="bottom-header" style="padding: 2px 0px 8px 0px;">
            <div class="feeScheduleHeader">
              <div class="feeScheduleHeaderChild">Rec. Global Surgery</div>
            </div>
          </th>
          <th class="bottom-header groupDividerEnd" style="padding: 2px 8px 8px 0px;">
            <div style="display: flex;">
              <div class="feeScheduleHeader">
                <div class="feeScheduleHeaderChild">Rec. Asst. at Surgery</div>
              </div>
              <div class="feeScheduleHeader">
                <div class="feeScheduleHeaderChild">Rec. Co-Surgeons</div>
              </div>
            </div>
          </th>
          <th colspan="2" class="groupDividerStart">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="cpt in worksheet.cpts"
          :key="cpt.cptId"
          class="cpt-row"
          :class="{ highlight: isCptRowChange(cpt) }"
        >
          <!-- Pre CPT -->
          <td :class="{ 'red-font': isPreCptRedFont(cpt) }">
            <div>{{ cpt.preCpt }}</div>
            <div
              v-if="isTrucodeEnabled()"
              class="feeScheduleData"
              title="Pre-CPT Work RVU"
              v-html="getPhysicianFeeScheduleData(cpt, 'workRvu', 2)"
            ></div>
          </td>
          <td :class="{ 'red-font': isPreCptRedFont(cpt) }">
            <div v-html="cptModifiers(cpt.preCptModifiers)"></div>
            <div
              v-if="isTrucodeEnabled()"
              :title="`Pre-CPT Global Surgery\n${getGlobalSurgeryTitle(getPhysicianFeeScheduleData(cpt, 'globalSurgery', 2))}`"
              class="feeScheduleData"
              v-html="getPhysicianFeeScheduleData(cpt, 'globalSurgery', 2)"
            ></div>
          </td>
          <td class="groupDividerEnd" :class="{ 'red-font': isPreCptRedFont(cpt) }">
            <div style="text-transform: lowercase;" :title="cpt.preCptDesc">{{ truncateDescription(cpt.preCptDesc) }}</div>
            <div v-if="isTrucodeEnabled()" style="display: flex;">
              <div style="flex: 1 1;">
                <div
                  title="Pre-CPT Assistant at Surgery"
                  class="feeScheduleData"
                  v-html="getPhysicianFeeScheduleData(cpt, 'assistantAtSurgery', 2)"
                ></div>
              </div>
              <div style="flex: 1 1;">
                <div style="padding-left: 5px;" class="feeScheduleData" v-html="getPhysicianFeeScheduleData(cpt, 'coSurgeons', 2)"></div>
              </div>
            </div>
          </td>

          <!-- Original (middle) CPT -->
          <td
            class="groupDividerStart"
            :class="{ 'red-font': isOriginalRedFont(cpt) }"
            :style="cpt.preCptDeleted ? 'text-decoration: line-through' : ''"
          >
            <div>{{ getOriginalCptCode(cpt) }}</div>
            <div
              v-if="isTrucodeEnabled()"
              class="feeScheduleData"
              title="Original Work RVU"
              v-html="getPhysicianFeeScheduleData(cpt, 'workRvu', 0)"
            ></div>
          </td>
          <td :class="{ 'red-font': isOriginalRedFont(cpt) }">
            <div v-html="cptModifiers(cpt.originalModifiers)"></div>
            <div
              v-if="isTrucodeEnabled()"
              :title="`Original Global Surgery\n${getGlobalSurgeryTitle(getPhysicianFeeScheduleData(cpt, 'globalSurgery', 0))}`"
              class="feeScheduleData"
              v-html="getPhysicianFeeScheduleData(cpt, 'globalSurgery', 0)"
            ></div>
          </td>
          <td class="groupDividerEnd" :class="{ 'red-font': isOriginalRedFont(cpt) }">
            <div style="text-transform: lowercase;" :title="getOriginalCptDescription(cpt)">
              {{ truncateDescription(getOriginalCptDescription(cpt)) }}
              <span
                v-if="cpt.originalGrouperFlags"
                :title="getGrouperflagsTitle(cpt.originalGrouperFlags)"
                class="grouperFlags"
              >({{ cpt.originalGrouperFlags }})</span>
            </div>
            <div v-if="isTrucodeEnabled()" style="display: flex;">
              <div style="flex: 1 1;">
                <div class="feeScheduleData" v-html="getPhysicianFeeScheduleData(cpt, 'assistantAtSurgery', 0)"></div>
              </div>
              <div style="flex: 1 1;">
                <div style="padding-left: 5px;" class="feeScheduleData" v-html="getPhysicianFeeScheduleData(cpt, 'coSurgeons', 0)"></div>
              </div>
            </div>
          </td>

          <!-- Recommended CPT -->
          <td
            class="groupDividerStart"
            :class="{ 'red-font': isRecommendedRedFont(cpt) }"
            :style="cpt.originalDeleted ? 'text-decoration: line-through' : ''"
          >
            <div>{{ getRecommendedCptCode(cpt) }}</div>
            <div
              v-if="isTrucodeEnabled()"
              class="feeScheduleData"
              title="Recommended Work RVU"
              v-html="getPhysicianFeeScheduleData(cpt, 'workRvu', 1)"
            ></div>
          </td>
          <td :class="{ 'red-font': isRecommendedRedFont(cpt) }">
            <div v-html="cptModifiers(cpt.recommendedModifiers)"></div>
            <div
              v-if="isTrucodeEnabled()"
              :title="`Recommended Global Surgery\n${getGlobalSurgeryTitle(getPhysicianFeeScheduleData(cpt, 'globalSurgery', 1))}`"
              class="feeScheduleData"
              v-html="getPhysicianFeeScheduleData(cpt, 'globalSurgery', 1)"
            ></div>
          </td>
          <td class="groupDividerEnd" :class="{ 'red-font': isRecommendedRedFont(cpt) }">
            <div style="text-transform: lowercase;" :title="getRecommendedCptDescription(cpt)">
              {{ truncateDescription(getRecommendedCptDescription(cpt)) }}
              <span
                v-if="showRecommendedGrouperFlags(cpt)"
                :title="getGrouperflagsTitle(cpt.recommendedGrouperFlags)"
                class="grouperFlags"
              >({{ cpt.recommendedGrouperFlags }})</span>
            </div>
            <div v-if="isTrucodeEnabled()" style="display: flex;" class="feeScheduleData">
              <div style="flex: 1 1;" v-html="getPhysicianFeeScheduleData(cpt, 'assistantAtSurgery', 1)"></div>
              <div style="flex: 1 1; margin-left: 10px;" v-html="getPhysicianFeeScheduleData(cpt, 'coSurgeons', 1)"></div>
            </div>
          </td>

          <td class="groupDividerStart" :class="{ 'red-font': isRecommendedRedFont(cpt) }">{{ cpt.reasonForChangeDescription }}</td>
          <td>
            <el-button
              :disabled="coderResponsesReadOnly()"
              style="margin-right: 5px;"
              size="mini"
              v-if="shouldShowRespond(cpt)"
              type="text"
              @click="addResponse(cpt)"
            >Respond</el-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import HiaAuthorization from '@/mixins/hiaAuthorization'
  import coderReviewStatusHelper from '@/mixins/coderReviewStatusHelper'
  import { mapMutations } from 'vuex'

  export default {
    name: 'coderProCptsPivoted',
    mixins: [HiaAuthorization, coderReviewStatusHelper],
    props: ['worksheet'],
    methods: {
      ...mapMutations('coder/', ['SET_RESPONSE_ROW']),
      truncateDescription(description) {
        const max = 100
        if (description && description.length > max) {
          return description.substring(0, max) + '...'
        }
        return description
      },
      getGrouperflagsTitle(flagList) {
        if (!flagList) {
          return
        }

        const flagMap = {
          AD: 'Affects DRG',
          CC: 'Complication/Comorbidity',
          HC: 'Hospital-Acquired Condition',
          MC: 'Complication/Comorbidity',
          R: 'Affects Risk of Mortality',
          S: 'Affects Severity of Illness',
          AP: 'Affects Patient Safety Indicators',
          EP: 'Excludes Patient Safety Indicators',
          AQ: 'Affects Quality Measures',
          EQ: 'Excludes Quality Measures',
          OR: 'Operative Procedure',
          NOR: 'Non-Operative Procedure'
        }

        const flags = flagList.split(',')
        const title = []
        flags.forEach(x => {
          title.push(`${x}: ${flagMap[x]}`)
        })

        return title.join('\n')
      },
      addResponse(row) {
        this.SET_RESPONSE_ROW(row)
        this.$nextTick(() => {
          const editor = document.getElementById('newCommentExistingRebuttal')
          if (editor) {
            editor.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
          }
        })
      },
      shouldShowRespond(cpt) {
        if (cpt.recommendedCpt || cpt.originalDeleted || cpt.preCptDeleted) {
          return true
        }
        if (cpt.recommendedModifiers && cpt.recommendedModifiers !== cpt.originalModifiers) {
          return true
        }
        if (cpt.originalCPT && cpt.preCpt && cpt.originalCPT !== cpt.preCpt) {
          return true
        }
        return false
      },
      isCptRowChange(cpt) {
        if (cpt.recommendedCpt || cpt.originalDeleted || cpt.preCptDeleted) {
          return true
        }
        if (cpt.recommendedModifiers && cpt.recommendedModifiers !== cpt.originalModifiers) {
          return true
        }
        if (cpt.originalCPT && cpt.preCpt && cpt.originalCPT !== cpt.preCpt) {
          return true
        }
        return false
      },
      isPreCptRedFont(cpt) {
        if (cpt.preCptDeleted || (cpt.originalDeleted && cpt.recommendedCpt !== cpt.preCpt)) {
          return true
        }
        return false
      },
      isOriginalRedFont(cpt) {
        return cpt.originalDeleted || cpt.preCptDeleted
      },
      isRecommendedRedFont(cpt) {
        return cpt.originalDeleted || cpt.preCptDeleted
      },
      getOriginalCptCode(cpt) {
        if (cpt.preCptDeleted) {
          return cpt.preCpt
        }
        return cpt.originalCPT
      },
      getOriginalCptDescription(cpt) {
        if (cpt.preCptDeleted) {
          return 'Delete Code'
        }
        return cpt.origDesc
      },
      getRecommendedCptCode(cpt) {
        if (cpt.originalDeleted) {
          const originalCalc = `${cpt.originalCPT || ''}${cpt.originalModifierCalc || ''}` || `${cpt.preCpt || ''}`
          return originalCalc || 'DEL'
        }
        if (cpt.recommendedCpt) {
          return cpt.recommendedCpt
        }
        if (cpt.calcRecCPT) {
          return cpt.calcRecCPT
        }
        return ''
      },
      getRecommendedCptDescription(cpt) {
        if (cpt.originalDeleted) {
          if (cpt.recDesc) {
            return `Delete CPT - ${cpt.recDesc}`
          }
          return 'Delete Code'
        }
        return cpt.recDesc
      },
      showRecommendedGrouperFlags(cpt) {
        return (
          (cpt.recommendedCpt && cpt.recommendedGrouperFlags) ||
          (cpt.recommendedGrouperFlags && cpt.recommendedGrouperFlags !== cpt.originalGrouperFlags)
        )
      },
      getPhysicianFeeScheduleData(cpt, field, level) {
        let data = null
        switch (level) {
          case 0:
            data = (cpt.originalCPT || (cpt.preCptDeleted && cpt.preCpt))
              ? this.worksheet.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level)
              : null
            break
          case 1:
            data = (cpt.recommendedCpt || cpt.originalDeleted || cpt.calcRecCPT)
              ? this.worksheet.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level)
              : null
            break
          case 2:
            data = cpt.preCpt
              ? this.worksheet.proRecordCptsPhysicianFeeSchedule.find(f => f.cptId === cpt.cptId && f.codeLevel === level)
              : null
            break
        }
        return data ? data[field] : '&nbsp;'
      },
      getGlobalSurgeryTitle(val) {
        const map = {
          '000': '000 - Endoscopic or minor procedure with related preoperative and postoperative relative values on the day of the procedure only included in the fee schedule payment amount; evaluation and management services on the day of the procedure generally not payable.',
          '010': '010 - Minor procedure with preoperative relative values on the day of the procedure and postoperative relative values during a 10 day postoperative period included in the fee schedule amount; evaluation and management services on the day of the procedure and during the 10-day postoperative period generally not payable.',
          '090': '090 - Major surgery with a 1-day preoperative period and 90-day postoperative period included in the fee schedule amount.',
          MMM: 'MMM - Maternity codes; usual global period does not apply.',
          XXX: 'XXX - The global concept does not apply to the code.',
          YYY: 'YYY - The carrier is to determine whether the global concept applies and establishes postoperative period, if appropriate, at time of pricing.',
          ZZZ: 'ZZZ - The code is related to another service and is always included in the global period of the other service.'
        }
        return map[val]
      },
      cptModifiers(modifiers) {
        if (modifiers) {
          const newMods = modifiers.replaceAll('-', '').split(' ').filter(Boolean).join(',')
          return newMods
        }
        return '&nbsp;'
      }
    }
  }
</script>

<style scoped>
  .grouperFlags {
    font-style: italic;
    text-transform: uppercase;
  }

  .red-font {
    color: red;
  }

  .cpt-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 0;
  }

  .hiaTable.level2 {
    overflow-x: auto;
  }

  .cpt-table .top-header {
    padding: 8px 8px 2px 8px;
    text-align: left;
    vertical-align: middle;
    background-color: #f5f7fa;
    font-weight: 600;
    border-bottom: 2px solid #e2e8f0;
  }

  .cpt-table .bottom-header {
    padding: 2px 8px 8px 8px;
    text-align: left;
    vertical-align: top;
    background-color: #f5f7fa;
    font-weight: 600;
    border-bottom: 2px solid #e2e8f0;
  }

  .cpt-table td {
    padding: 8px;
    padding-bottom: 40px;
    text-align: left;
    vertical-align: top;
    position: relative;
    font-size: 13px;
  }

  .cpt-table tbody tr:nth-child(even) {
    background-color: #fafafa;
  }

  .cpt-table tbody tr {
    border-top: 1px solid #e2e8f0;
  }

  .groupDividerStart {
    border-left: 1px solid #c0c4cc !important;
  }

  .groupDividerEnd {
    border-right: 1px solid #c0c4cc !important;
  }

  .codeTypeHeader {
    text-align: left;
    padding: 4px 8px 4px 8px;
    border-left: 8px solid #3378aa7c;
    color: #2c3e50;
    font-style: italic;
    font-weight: normal;
    background-color: #f5f7fa;
  }

  .codeTypeHeader.groupBlock {
    border-right: 1px solid #c0c4cc;
  }

  .codeTypeHeader.groupDividerStart {
    border-left: 1px solid #c0c4cc;
  }

  .code-type-header-row th {
    border-bottom: 1px solid #ebeef5;
  }

  .oneHundredPx {
    width: 100px;
  }

  .seventyFivePx {
    width: 75px;
  }

  .twentyPercent {
    width: 20%;
  }

  .reasonForChangeCol {
    min-width: 120px;
  }

  .responseCol {
    min-width: 80px;
  }

  >>> .highlight {
    font-weight: bold;
    border-left: 3px solid #f56c6c;
  }

  >>> .feeScheduleHeader {
    color: #005695;
    border-top: 1px solid rgb(204, 204, 204);
    margin-top: 2px;
    padding-top: 2px;
    font-weight: normal;
    font-size: 11px;
  }

  >>> .feeScheduleHeaderChild {
    margin: 0px 8px 8px 8px;
  }

  >>> .feeScheduleData {
    border-top: 1px solid rgb(204, 204, 204);
    padding-top: 5px;
    font-size: 11px;
    position: absolute;
    bottom: 8px;
    left: 8px;
    right: 8px;
    color: #005695;
  }

  .cpt-table.truCodeEnabled td {
    position: relative;
    padding-bottom: 32px;
  }
</style>
